import { render, staticRenderFns } from "./STotalSaleMobileComp.vue?vue&type=template&id=5de6b9d6&"
import script from "./STotalSaleMobileComp.vue?vue&type=script&lang=js&"
export * from "./STotalSaleMobileComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports